<div class="card dg-card" style="width: 100%;">
  <ng-content></ng-content>
</div>
